module.exports = __webpack_public_path__ + "img/W-15.cd216a79.jpg";